/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { CustomTextClassStore } from 'src/customText/core/stores/CustomTextClassStore';

export class CustomTextClassificationStore {
    @observable public classes: CustomTextClassStore[];

    constructor(classes: CustomTextClassStore[]) {
        this.classes = classes;
    }

    /**
     * Adds a new class to the extraction store
     * @param name name of the new class
     */
    @action
    public addClass(name: string) {
        this.classes.push(new CustomTextClassStore({ name }));
    }

    /**
     * Deletes a number of classes by their Ids
     * @param classIds Ids of classes to be deleted
     */
    @action
    public deleteClassesByIds(classIds: string[]) {
        this.classes = this.classes.filter(e => !classIds.includes(e.id));
    }

    /**
     * Renames an class by Id
     * @param param0
     */
    @action
    public renameClassById(id: string, newName: string) {
        this.classes.find(e => e.id === id).renameClass(newName);
    }
}
